/** The thin light-green strip under the header, per the reference screenshot. */
export function PromoBanner() {
  return (
    <div className="public__promo" role="note">
      Explore our newest rentals on our brand new platform! | Call or text us today at 866-725-2249
      for more information.
    </div>
  );
}
